import { styled } from '@mui/material/styles'
import { HorizontalTabs } from 'packages/eid-ui'

const Tabs = styled(HorizontalTabs)(({ theme }) => ({
    '& .MuiTabs-flexContainer': {
        height: '61px',
    },
    '& .MuiTabs-indicator': {
        backgroundColor: theme?.palette?.primary?.main,
    },
    '& .MuiTab-textColorInherit.Mui-selected': {
        fontWeight: 'bold',
    },
    borderBottom: 'solid 1px #d8dadd',
}))

Tabs.Tab = HorizontalTabs.Tab

export default Tabs
